import React from 'react'
import { useDispatch } from 'react-redux'
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import { translateBase } from '../../helpers'
import { unLinkCollateral } from 'src/store/loan'

const unlinkLoanCollateralModal = 'unlinkLoanCollateralModal'
const unlinkLoanCollateralFetcher = 'unlinkLoanCollateralFetcher'

const UnlinkCollateralModal = (props) => {
  const {
    params: { ID, hash, CollateralID, CollateralHash },
    onFinish,
  } = props

  const dispatch = useDispatch()

  function handleConfirm() {
    // dispatch(
    //   fetchSFM({
    //     instanceName: unlinkLoanCollateralFetcher,
    //     callApi: Loan.unlinkCollateral,
    //     callApiArgs: [ID, hash, CollateralID, CollateralHash],
    //     resolve: onFinish,
    //     reject: (error) => {
    //       dispatch(LKModalActions.openError(translateBase(error.Error.Message || error.Error.Text)))
    //     },
    //   }),
    // )

    //UPDATED API REQUEST loan_oper_api page: unlinkcollateral
    dispatch(
      unLinkCollateral({
        LoanID: ID,
        HashSum_LoanID_: hash,
        CollateralID: CollateralID,
        HashSum_CollateralID_: CollateralHash,
      }),
    ).then((response) => {
      if (!unLinkCollateral.fulfilled.match(response)) {
        dispatch(LKModalActions.openInfo(translateBase(response.payload)))
        return
      }
      onFinish()
    })
  }

  return <LKModal.Confirmation name={unlinkLoanCollateralModal} onConfirm={handleConfirm} />
}

export const open = (ID, hash, CollateralID, CollateralHash) =>
  LKModalActions.openConfirmation(unlinkLoanCollateralModal, {
    message: translateBase('CONFIRM_COLL_DETACH'),
    ID,
    hash,
    CollateralID,
    CollateralHash,
  })

export default LKModalContainer(unlinkLoanCollateralModal)(UnlinkCollateralModal)
